<template>
  <div v-if="reportStatus.Data">
    <about-item name="报活成功次数:"> {{reportStatus.SuccessCount ? reportStatus.SuccessCount : 0}} </about-item>
    <about-item name="报活失败次数"> {{reportStatus.FailCount ? reportStatus.FailCount : 0}} </about-item>
    <about-item name="报活目标"> {{reportStatus.Target }} </about-item>
    <about-item name="报活间隔"> {{reportStatus.Interval }}s </about-item>
    <about-item name="报活设备 ID"> {{reportStatus.Data.MachineID }} </about-item>
    <about-item name="报活应用 ID"> {{reportStatus.Data.AppID }} </about-item>
    <about-item name="报活应用版本"> {{reportStatus.Data.Ver }} </about-item>
    <about-item name="报活应用类型"> {{reportStatus.Data.RelType }} </about-item>
    <about-item name="报活系统"> {{reportStatus.Data.OS }} </about-item>
    <about-item name="报活架构"> {{reportStatus.Data.Arch }} </about-item>
    <about-item name="报活运行环境"> {{reportStatus.Data.RunIn }} </about-item>
    <el-button @click="refresh" size="mini">刷新报活数据</el-button>
  </div>
</template>

<script>
import AboutItem from './aboutItem.vue'

export default {
  name: "alive",
  components: {
    AboutItem,
  },
  data() {
    return {
      reportStatus: {},
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      let self = this
      this.api.report.getReport((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        } else {
          console.log('API called successfully. Returned data: ', data)
          self.reportStatus = data
        }
      })
    },
  }
}
</script>